import styled from 'styled-components';

import { colors } from '@dexma/ui-components';
import { headerHeight } from 'adapter/in/dashboards/pages/globalStyles';

type EditDashboardHeaderProps = {
    $isEditingLayout: boolean;
};
export const StyledEditDashboardHeader = styled.div<EditDashboardHeaderProps>`
    height: ${headerHeight};
    border-bottom: 1px solid #c9cccf;
    display: grid;
    grid-template-columns: ${(props) => (props.$isEditingLayout ? `1fr auto 1fr;` : `auto 1fr`)};
    background-color: ${colors.gray100};
    .menu-settings {
        text-align: right;
    }
    .edit-name-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 20px;

        svg {
            cursor: pointer;
        }

        .edit-name-disabled {
            cursor: not-allowed;
        }

        span {
            color: ${colors.gray800};
            font-weight: 600;
        }
        input {
            margin-right: 10px;
        }
    }

    .layout-fieldgroup {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .button-wrapper {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        button {
            margin-right: 10px;
        }
    }
`;
